import React, { useRef, useState, useEffect } from 'react'
import './SkillsSection.css'

const SKILL_GROUPS = [
  {
    category: 'Web & Frontend',
    icon: '◈',
    color: '#00ff88',
    skills: [
      { name: 'React / Vite', level: 90 },
      { name: 'Vue.js', level: 80 },
      { name: 'HTML / CSS', level: 95 },
      { name: 'JavaScript', level: 88 },
      { name: 'PHP', level: 72 },
    ]
  },
  {
    category: 'Data & IA',
    icon: '◎',
    color: '#00aaff',
    skills: [
      { name: 'Python', level: 85 },
      { name: 'Machine Learning', level: 75 },
      { name: 'R', level: 65 },
      { name: 'SQL / PostgreSQL', level: 88 },
      { name: 'MySQL', level: 85 },
    ]
  },
  {
    category: 'Backend & Systèmes',
    icon: '◉',
    color: '#a78bfa',
    skills: [
      { name: 'C#', level: 68 },
      { name: 'Node.js', level: 70 },
      { name: 'BDD / MCD / MLD', level: 85 },
      { name: 'OVH / Hostinger', level: 80 },
      { name: 'Oracle Cloud', level: 65 },
    ]
  },
  {
    category: '3D & Créatif',
    icon: '✦',
    color: '#f59e0b',
    skills: [
      { name: 'Three.js', level: 72 },
      { name: 'React Three Fiber', level: 68 },
      { name: 'Design Responsive', level: 90 },
      { name: 'UI/UX', level: 78 },
      { name: 'Figma', level: 65 },
    ]
  },
]

const TECH_TAGS = [
  'React', 'Vue.js', 'Vite', 'PHP', 'Python', 'R', 'C#',
  'SQL', 'MySQL', 'PostgreSQL', 'Three.js', 'Machine Learning',
  'HTML', 'CSS', 'JavaScript', 'Node.js', 'OVH', 'Hostinger', 'Oracle',
  'MCD', 'MLD', 'React Three Fiber', 'Figma',
]

function useReveal(threshold = 0.1) {
  const ref = useRef(null)
  const [visible, setVisible] = useState(false)
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) { setVisible(true); obs.disconnect() }
    }, { threshold })
    if (ref.current) obs.observe(ref.current)
    return () => obs.disconnect()
  }, [threshold])
  return [ref, visible]
}

function SkillBar({ name, level, visible, delay }) {
  return (
    <div className="skill-bar-row">
      <div className="skill-bar-header">
        <span className="skill-bar-name">{name}</span>
        <span className="skill-bar-pct">{level}%</span>
      </div>
      <div className="skill-bar-track">
        <div
          className="skill-bar-fill"
          style={{
            '--level': `${level}%`,
            transitionDelay: visible ? `${delay}ms` : '0ms',
          }}
        />
      </div>
    </div>
  )
}

export default function SkillsSection() {
  const [sectionRef, visible] = useReveal()

  return (
    <section id="skills" className="section skills-section" ref={sectionRef} aria-label="Compétences">
      <div className={`section-inner ${visible ? 'visible' : ''}`}>
        <div className="section-label"><span>02</span> Compétences</div>
        <h2 className="section-title">
          Stack <span className="gradient-text">technique</span>
        </h2>
        <p className="section-desc">
          Du frontend au machine learning, en passant par les bases de données et les applications desktop.
        </p>

        {/* Skill groups grid */}
        <div className="skills-grid">
          {SKILL_GROUPS.map((group, gi) => (
            <div
              key={group.category}
              className="skill-group glass-card"
              style={{ '--group-color': group.color, '--delay': `${gi * 80}ms` }}
            >
              <div className="skill-group-header">
                <span className="skill-group-icon" style={{ color: group.color }}>{group.icon}</span>
                <h3 className="skill-group-title">{group.category}</h3>
              </div>
              <div className="skill-bars">
                {group.skills.map((s, si) => (
                  <SkillBar
                    key={s.name}
                    {...s}
                    visible={visible}
                    delay={gi * 80 + si * 80 + 200}
                  />
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Tag cloud */}
        <div className="tech-cloud">
          <p className="tech-cloud-label">Toutes les technologies</p>
          <div className="tech-tags">
            {TECH_TAGS.map((tag, i) => (
              <span
                key={tag}
                className="tech-tag"
                style={{ '--ti': i }}
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}
